import Oidc from 'oidc-client';
import authService from './auth.service';

angular.module('rym.auth', []).constant('Oidc', Oidc).service('authService', authService);
